import React from "react";

import { CallSessionProvider } from "./CallSessionProvider";
import CallSessionModal from "./CallSessionModal";
import IncomingCallBubble from "./IncomingCallBubble";

type THomeCallSessionBoundaryProps = React.PropsWithChildren;

const HomeCallSessionBoundary: React.FC<THomeCallSessionBoundaryProps> = ({
  children,
}) => {
  return (
    <CallSessionProvider>
      {children}
      <IncomingCallBubble />
      <CallSessionModal />
    </CallSessionProvider>
  );
};

export default HomeCallSessionBoundary;
